export default "__VITE_ASSET__POVP$2Px__"